const colors = {
  // White
  white: '#FFFFFF',
  darkIce: '#F3F1EF',
  ice: '#F7F8FC',

  // Gray
  lightgray: '#e3e4e6',
  lightgray1: '#e1e2e3',
  gray: '#707070',
  gray2: '#888C99',
  darkgray: '#424244',
  graylink: '#898a8e',
  graysecondary: '#888A8E',
  gray3: '#B3B3B3',
  gray4: '#DDDEDF',
  gray5: '#9EA0A3',

  // Gold
  gold: '#D4A048',
  darkgold: '#936923',
  lightgold: '#DF9639',

  // orange
  orange: '#F0AF50',

  // Black
  lightblack: '#222931',
  black: '#000000',

  // Blue
  lightpastelblue: '#C8D5E5',
  lightpastelblue0: '#99B1D0',
  lightpastelblue1: '#8290B2',
  lightpastelblue2: '#7091BD',
  lightpastelblue3: '#4D77AD',
  lightpastelblue4: '#2196F3',
  pastelblue: '#3161A0',
  pastelblue2: '#1B46AF',
  pastelblue3: '#1B5096',
  pastelblue4: '#0B458F',
  blue: '#023E8B',
  blue2: '#2E4099',
  darkblue: '#0E2A6B',
  blueEinstein: '#004F92',
  blueEinstein2: '#1F649F',
  blueEinstein3: '#2468A1',
  blueDropdown: '#2684FF',

  danger: '#ff002b',
  warning: '#ff7736',
  warningInput: '#FAAA2F',
};

export default colors;
